/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';
import { isCallcenterLoggedIn, getCallcenterUser } from './callcenterService';

const baseUrl = `${process.env.BACKEND_API_BASE_URL}/jobs.php`;

const getToken = () => (isCallcenterLoggedIn() ? getCallcenterUser() : getLoginUser()).token;

// Dispatcher fixes are app-driven: 'set_status'/'noshow' only PUSH a request to the
// driver app, and the event stays pending ("updating…") until the poll sees the job
// status change. After this many seconds with no change, treat it as no response.
export const TRIP_MONITOR_REQUEST_TIMEOUT_SEC = 90;

// 8 (Completed): account trips — "Set Complete" runs Drop Off -> Pay -> Complete in the app.
export const TRIP_MONITOR_TARGET_LABEL = { 5: 'Picked Up', 6: 'Dropped Off', 8: 'Completed', 9: 'No Show' };

// 'none' (no request sent yet) | 'waiting' (sent, inside the timeout window) | 'timeout'
export const tripMonitorRequestState = alert => {
  if (!alert || alert.requested_status == null) return 'none';
  const ago = parseInt(alert.requested_ago, 10);
  return Number.isFinite(ago) && ago < TRIP_MONITOR_REQUEST_TIMEOUT_SEC ? 'waiting' : 'timeout';
};

export const tripMonitorService = {
  // Pending geofence exit-without-status events — polled to drive the banner/pill/modal.
  get_trip_monitor_alerts: async (data = {}) =>
    axios.get(baseUrl, {
      params: {
        method: 'get_trip_monitor_alerts',
        token: getToken(),
        ...data, // { dbname } for call center
      },
    }),
  // Dispatcher fix. action: 'set_status' | 'noshow' | 'cancel' | 'dismiss'.
  resolve_trip_monitor_alert: async (eventId, action, data = {}) =>
    axios.get(baseUrl, {
      params: {
        method: 'resolve_trip_monitor_alert',
        event_id: eventId,
        action,
        token: getToken(),
        ...data,
      },
    }),
};
